import { useMemo } from 'react';

import { FormulaTypesData } from '../../models/formula.model';

import { AuditRefs } from '../../views/activity-logs/references';

import useCompoundTriggers from '../compound-trigger/useCompoundTriggers';
import useAttributeOperatorsQuery from '../filters/useAttributeOperatorsQuery';

// Frequency limits store a channel as its FormulaType; label it as the frequency
// limits page does. (The channel-definition list is pilot-gated, so not used here.)
const CHANNEL_NAMES = new Map<string, string>(
    Object.values(FormulaTypesData).map((type) => [type.key, type.title]),
);

/** Trigger and channel names for audit entries, from data the app already has. */
export default function useAuditRefs(): AuditRefs {
    const { data: triggers } = useCompoundTriggers();
    const { data: operators } = useAttributeOperatorsQuery();

    return useMemo(
        () => ({
            triggerNames: new Map(
                (triggers ?? []).map((t) => [String(t.id), t.name]),
            ),
            channelNames: CHANNEL_NAMES,
            operatorNames: new Map(
                (operators ?? []).map((op) => [String(op.id), op.display_name]),
            ),
        }),
        [triggers, operators],
    );
}
